export const DESIGN_SYSTEM_ROOT_MAPPING = {
  primaryColor: "--theme-color-1",
  secondaryColor: "--theme-color-2",
  themeColor3: "--theme-color-3",
  themeColor4: "--theme-color-4",
  backgroundColor: "--background-main-color",
  backgroundColor2: "--background-secondary-color",

  hyperlinkColor: "--hyperlinks-text-color",
  hyperlinkHoverColor: "--hyperlinks-text-hover-color",
  hyperlinkUnderline: "--hyperlinks-underline",
  hyperlinkBold: "--hyperlinks-bold",
  hyperlinkItalic: "--hyperlinks-italic",

  highlightTextColor: "--highlight-text-color",
  highlightColor: "--highlight-background-color",

  rkpiFontSize: "--rkpi-font-size",

  buttonRadius: "--button-border-radius",
  buttonBackgroundColor: "--button-background-color",
  buttonBackgroundHoverColor: "--button-background-hover-color",
  buttonColor: "--button-text-color",
  buttonHoverColor: "--button-text-hover-color",
  buttonBorderWidth: "--button-border-width",
  buttonBorderColor: "--button-border-color",
  buttonBorderColorHover: "--button-border-color-hover",
  secondaryButtonRadius: "--secondary-button-border-radius",
  secondaryButtonBackgroundColor: "--secondary-button-background-color",
  secondaryButtonBackgroundHoverColor:
    "--secondary-button-background-hover-color",
  secondaryButtonColor: "--secondary-button-text-color",
  secondaryButtonHoverColor: "--secondary-button-text-hover-color",
  secondaryButtonBorderWidth: "--secondary-button-border-width",
  secondaryButtonBorderColor: "--secondary-button-border-color",
  secondaryButtonBorderColorHover: "--secondary-button-border-color-hover",

  displayFont: "--display-font",
  displayStyle: "--display-style",
  displayFontSize: "--display-size",
  mobileDisplayFontSize: "--display-mobile-size",
  displayColor: "--display-color",
  displayTextTransform: "--display-text-transform",

  titleColor: "--title-color",
  titleFont: "--title-font",
  titleStyle: "--title-style",
  titleFontSize: "--title-size",
  mobileTitleFontSize: "--title-mobile-size",
  titleTextTransform: "--title-text-transform",
  titleMargin: "--title-margin-bottom",

  headingFont: "--heading-font",
  headingStyle: "--heading-style",
  headingFontSize: "--heading-size",
  mobileHeadingFontSize: "--heading-mobile-size",
  headingColor: "--heading-color",
  headingTextTransform: "--heading-text-transform",

  subtitleColor: "--subtitle-color",
  subtitleFont: "--subtitle-font",
  subtitleStyle: "--subtitle-style",
  subtitleFontSize: "--subtitle-size",
  mobileSubtitleFontSize: "--subtitle-mobile-size",
  subtitleTextTransform: "--subtitle-text-transform",
  subtitleMargin: "--subtitle-margin-bottom",
  paragraphColor: "--paragraph-color",
  paragraphFont: "--paragraph-font",
  paragraphStyle: "--paragraph-style",
  paragraphFontSize: "--paragraph-size",
  mobileParagraphFontSize: "--paragraph-mobile-size",
  paragraphTextTransform: "--paragraph-text-transform",
  paragraphMargin: "--paragraph-margin-bottom",

  mediaOverlayColor: "--media-overlay-color",
  mediaOverlayOpacity: "--media-overlay-opacity",
  mediaCornerRadius: "--media-corner-radius",
  mediaBlackAndWhiteFilter: "--media-black-and-white-filter",
  mediaShadowColor: "--media-shadow-color",
  mediaShadowOpacity: "--media-shadow-opacity",
};
